import EndpointComp from 'developer-docs-shared-components/components/endpoint/EndpointComp';
import { jsx as _jsx } from "react/jsx-runtime";
function Endpoint({
  method,
  path
}) {
  return /*#__PURE__*/_jsx(EndpointComp, {
    className: "m-bottom-6",
    method: method,
    path: path
  });
}
export default Endpoint;